import { render, staticRenderFns } from "./ver.vue?vue&type=template&id=1d7f9128&scoped=true&"
import script from "./ver.vue?vue&type=script&lang=js&"
export * from "./ver.vue?vue&type=script&lang=js&"
import style0 from "./ver.vue?vue&type=style&index=0&id=1d7f9128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f9128",
  null
  
)

export default component.exports